import { render, staticRenderFns } from "./Ordo.vue?vue&type=template&id=13092025&scoped=true&"
import script from "./Ordo.vue?vue&type=script&lang=js&"
export * from "./Ordo.vue?vue&type=script&lang=js&"
import style0 from "./Ordo.vue?vue&type=style&index=0&id=13092025&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13092025",
  null
  
)

export default component.exports